import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from './../../Header';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class PartnerContact extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            contactus: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            activePage: 1,
            item_count: '',
            message: '',
            fromdate: '',
            from_date: '',
            todate: '',
            to_date: '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            search: '',
            isLoadMore: 1,
            loading: 1,

        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.formdateChange = this.formdateChange.bind(this);
        this.todateChange = this.todateChange.bind(this);
        this.keywordChange = this.keywordChange.bind(this);
        this.getSourceLink = this.getSourceLink.bind(this);
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }
    getSourceLink(link)
    {
        if(link){
            if(link.indexOf('http') !== -1)
            {
                var linknew = <a href={`${link}`}>{`${link}`}</a>;
                return linknew
            }
            else
            {return link}
        } else {
            let na = 'NA';
            return na;
        }  
    }
    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    formdateChange(event) {
        this.setState({
            fromdate: event,
            from_date: moment(event).format("YYYY-MM-D"),
            activePage: 1
        }, function () {
            this.contactList();
        });
    }
    todateChange(event) {
        this.setState({
            todate: event,
            to_date: moment(event).format("YYYY-MM-D"),
            activePage: 1
        }, function () {
            this.contactList();
        });
    }
    keywordChange(event) {
        var obj = this;
        this.setState({ search: event.target.value,activePage: 1});
        if (this.timer) {
            window.clearTimeout(this.timer);
    }
        this.timer = window.setTimeout(function () {
            obj.contactList();
        }, 500);
    }
    back() {
        window.location.href = '/ContactUs';
    }
    export() {
        var win = window.open(this.state.apiUrl + "/AdvancedRest/ExportAdvanced/userAuthKey/" + this.state.userAuthKey + "/type/partnercontact/fromdate/" + this.state.from_date + "/todate/" + this.state.to_date + "/search/" + this.state.search, '_self');
        win.focus()
    }
    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/AdvancedRest/PartnerContact/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        contactus: findresponse.contactus,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }
    }
    contactList(page = 1) {
        fetch(this.state.apiUrl + '/AdvancedRest/PartnerContact/page/' + page + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                this.setState({
                    loading: 0,
                    contactus: findresponse.contactus,
                    item_count: findresponse.item_count,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            })
    }

    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        }
        else {
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }

    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });

        fetch(this.state.apiUrl + '/AdvancedRest/PartnerContact/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.contactus.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                }
                else {
                    this.setState({
                        isLoadMore: 1
                    })
                }
                this.setState({
                    contactus: this.state.contactus.concat(findresponse.contactus),
                })

            })
    }
    componentDidMount() {
        document.title = "Intranet | Contacts";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.contactList();
        $(document).ready(function () {
            //Page Refresh
            setTimeout(function () {
                //ticketsList();
                // window.location.reload();
            }, 10000);
            //Responsive filter
            $('.top-row .fa-sliders').on('click', function () {
                $(this).closest('.intranet_body').find('.form-section').slideToggle('slow');
            });
        });
    }
    getCustomerDetails() {
        if (this.state.loading) {
            return (
                <div>
                    <div class="loader-new"></div>
                </div>
            )
        } else {
            return (
                <div class="list_check">
                    <div class="tickets hidden-sm">
                        <ul class="tickets_head adv">
                            <li class="intra_col_10">Name</li>
                            <li class="intra_col_10">Email</li>
                            <li class="intra_col_10">company</li>
                            <li class="intra_col_10">Phone</li>
                            <li class="intra_col_10">Country</li>
                            <li class="intra_col_10">Partner Name</li>
                            <li class="intra_col_10">partner Email</li>
                            <li class="intra_col_10">Source</li>
                            <li class="intra_col_10">Ip Address</li>
                            <li class="intra_col_10">Date</li>
                        </ul>
                        {
                            this.state.contactus.map((contact, key) =>
                                <ul class="tickets_number" >
                                    <Link key={key} to={`/Partnercontdetails/${contact.id}`} name={"max"}>
                                        <li class="intra_col_10"> {contact.name}</li>
                                    </Link>
                                    <li class="intra_col_10"><a href={"mailto:" + contact.email} alt="Email">{contact.email}</a></li>
                                    <li class="intra_col_10"> {contact.company}</li>
                                    <li class="intra_col_10"> {(contact.country_code? contact.country_code+'-': '')+contact.phone}</li>
                                    <li class="intra_col_10">{contact.country}</li>
                                    <li class="intra_col_10">{contact.partner_name}</li>
                                    <li class="intra_col_10"> {contact.partner_email_address}</li>
                                    <li class="intra_col_10 text-inded">{this.getSourceLink(contact.source)}</li>
                                    <li class="intra_col_10"> {contact.ip_address}</li>
                                    <li class="intra_col_10">{contact.created_date}</li>
                                </ul>

                            )
                        }
                    </div>
                    <div class="tickets_mob hidden-md">
                        {
                            this.state.contactus.map((contact, key) =>
                                <Link key={key} to={`/Partnercontdetails/${contact.id}`} name={"max"}>
                                    <div class="list_mob">
                                        {/* <span onClick={()=> this.goToTicketDetails(todo.id,todo.assigned_to,todo.owner_name)}> */}
                                        <div class="section word-break">
                                            <div class="wrap pull-left">
                                                {contact.name}
                                            </div>

                                        </div>
                                        <div class="section gry">
                                            <div class="wrap">
                                                <span>{contact.company}</span>
                                            </div>
                                        </div>
                                        {/* </span> */}
                                    </div>
                                </Link>
                            )
                        }
                    </div>
                    {this.state.item_count > 0 ? <div class="pagination-muvi">
                        <Pagination
                            itemClass={'pages'}
                            itemClassFirst={'first_page'}
                            itemClassPrev={'prev_page'}
                            itemClassNext={'next_page'}
                            itemClassLast={'last_page'}
                            activePage={this.state.activePage}
                            itemsCountPerPage={20}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={5}
                            onChange={this.state.setPage == 'yes' ? this.handlePageChange : ''}
                        />
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                        </div>
                    </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                    {/* {this.loadMorecount()} */}

                </div>
            )
        }
    }

          handleApply = (event, picker) => {
        picker.element.val(
          picker.startDate.format('DD/MM/YYYY') +
            ' - ' +
            picker.endDate.format('DD/MM/YYYY')
        );
        this.setState({
            from_date: picker.startDate.format('YYYY-MM-D'),
            to_date: picker.endDate.format('YYYY-MM-D')
        }, () => {
            this.contactList()
        })
    };


    applyHandler = (event, picker) =>
    {
        this.setState({
            from_date: picker.startDate.format('YYYY-MM-D'),
            to_date: picker.endDate.format('YYYY-MM-D')
        }, () => {
            this.contactList()
        })
    }
    
    handleCallback( start, end, label ){

        console.log(start, end, label);
    }

    handleEvent = (event, picker) =>{
        this.setState({
          inputStart: picker.startDate.format('YYYY/MM/D'),
          inputFinish: picker.endDate.format('YYYY/MM/D')
        });
      }

      onCancel = (event, picker) => {

        this.setState({

            from_date: '',
            to_date: ''
        }, () => {

            this.contactList();
            picker.element.val(
                'From Date - To Date'
              );


        })
  }

  
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Partner Contacts" brecum_page="Partner Contacts" />
                <div class="right_col">

                    <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
                            <span>Partner Contacts</span>
                            <div class="mob-search hidden-md pull-right">
                                <i class="fa fa-search"></i>
                                <i class="fa fa-sliders" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="top-row">
                            <div class="row">
                                <div class="form-group col-sm-4 col-xs-4 icon-calender">
                                            <div class="filter">
                                            <DateRangePicker 
                                             initialSettings={{
                                                showDropdowns: true,
                                                
                                                autoUpdateInput: false,
                                                linkedCalendars:false,
                                                locale: {
                                                    cancelLabel: 'Clear',
                                                },

                                            }}
    
                                            onCallback={this.handleCallback}
                                            onApply={this.handleApply}
                                            onEvent={this.handleEvent}
                                            onCancel={this.onCancel}
                                            >
                                                <input className="form-control" defaultValue="" placeholder="From Date - To Date"/>
                                            </DateRangePicker>
                                            </div>
                                            <i class="fal fa-calendar-alt"></i>
                                        </div>
                                
                                    <div class="col-sm-6 col-xs-6 float-right" style={ {float: 'right'} }>
                                        <div class="searchTicket mob_100">
                                            <input type="text" class="form-control" name="customer" id="customer" placeholder="Search by name, email or company" onChange={this.keywordChange} /><button type="submit"><i class="fa fa-search"></i></button>
                                        </div>

                                </div>
                            </div>
                        </div>
                        {this.getCustomerDetails()}
                    </div>
                </div>
            </div>
        )
    }
}
export default PartnerContact


// WEBPACK FOOTER //
// ./src/components/advanced/PartnerContact.js